import React from "react";
import UniversalLink from "§/src/utils/UniversalLink"
import { sanitize } from "§/src/utils/functions";

// ASSETS
import Linkedin from '§/src/images/svg/icons/Social-linkedin.svg';
import Youtube from '§/src/images/svg/icons/Social-youtube.svg';
import Instagram from '§/src/images/svg/icons/Social-instagram.svg';
import Wechat from '§/src/images/svg/icons/Social-wechat.svg';

// MENUS
import LangMenu from '§/src/components/menus/lang-menu';
import BaseMenu from '§/src/components/menus/base-menu';
import WidgetMenu from '§/src/components/menus/widget-menu';

// Language
import { useTranslation } from 'react-i18next';

const Footer = ( { data, lang, langReplace } ) => {

	const { t } = useTranslation();
	const footerMenu1 = data.footerMenu1;
	const footerMenu2 = data.footerMenu2;
	const footerMenu3 = data.footerMenu3;
	const footerMenu4 = data.footerMenu4;
	const socialMenu = data.socialMenu;
	const langMenu = data.langMenu;
	const legalMenu = data.legalMenu;

	const footerOptions = data.footerOptions.acfoptGlobalOptions.acfGlobal;
	const general = data.footerOptions.generalSettings;

	return (
		<footer className="footer">

			{/*	Top section*/}
			<div className="footer-top pt-4 pb-3">
				<div className="row pt-4 justify-content-between">

					{
						footerMenu1.nodes.length ? (
							<WidgetMenu wpMenu={ footerMenu1 } className="col-6 col-sm-7 col-md-3 col-xl-auto pe-xl-5 me-xl-5 mb-4 pb-4 mb-lg-0 pb-lg-0" menuTitle={t('Prodotti e soluzioni')}></WidgetMenu>
						) : null
					}


					{
						footerMenu2.nodes.length ? (
							<WidgetMenu wpMenu={ footerMenu2 } className="col-6 col-sm-5 col-md-3 col-xl-auto pe-xl-5 me-xl-5 mb-4 pb-4 mb-lg-0 pb-lg-0" menuTitle={t('Gruppo')}></WidgetMenu>
						) : null
					}

					{
						footerMenu3.nodes.length ? (
							<WidgetMenu wpMenu={ footerMenu3 } className="col-6 col-sm-7 col-md-3 col-xl-auto pe-xl-5 me-xl-5" menuTitle={t('Investor relations')}></WidgetMenu>
						) : null
					}

					{
						footerMenu4.nodes.length ? (
							<WidgetMenu wpMenu={ footerMenu4 } className="col-6 col-sm-5 col-md-3 col-xl-auto pe-xl-5 me-xl-5" menuTitle={t('Supporto')}></WidgetMenu>
						) : null
					}


					{
					socialMenu.nodes.length ?
						<div id="social-bottom" className="social-list col-6 col-xl-auto ms-xl-auto flex-row flex-xl-column order-1 order-xl-0">
					    {socialMenu.nodes.map((menuItem, index) => {

					      if(menuItem.cssClasses.includes('linkedin')){
					        var Linkcontent = Linkedin;
					      } else if(menuItem.cssClasses.includes('youtube')){
					        var Linkcontent = Youtube;
					      } else if(menuItem.cssClasses.includes('instagram')){
					        var Linkcontent = Instagram;
					      } else if(menuItem.cssClasses.includes('wechat')){
					        var Linkcontent = Wechat;
					      } else {
					        var Linkcontent = menuItem.title;
					      }

					      return(
					        <button type="button" className="btn btn-sm btn-link" aria-label={ menuItem.title } key={index}>
					          <UniversalLink
					            className="text-light"
											target="_blank"
											to={ menuItem.uri }
					            activeClassName="active"
					          >
					            <Linkcontent></Linkcontent>
											<span className="h7">
												{ menuItem.title }
											</span>
					          </UniversalLink>
					        </button>
					      )
					    })}
						</div> :
					null
					}

					<div className="col-12 w-100 order-3 order-xl-0 d-xl-none pt-3"><hr className="my-0"></hr></div>

					<div className="w-100">&nbsp;</div>

					<div className="footer-copy col-auto order-4 order-xl-0">
						{
						footerOptions.footerAzienda ?
							<p className="mb-0" dangerouslySetInnerHTML={ { __html: sanitize(footerOptions.footerAzienda) } }></p>
						: null
						}
					</div>

					<div className="footer-language col-6 col-xl-auto order-2 order-xl-0">
						<LangMenu lang={lang} langReplace={langReplace} wpMenu={ langMenu } general={ general } className="dropup" buttonClass="btn-link text-white pb-0 pe-0" theme="dropdown-menu"></LangMenu>
					</div>

				</div>
			</div>


			{/*	Bottom bottom*/}
			<div className="footer-bottom pb-5">
				<div className="row">
				<div className="ruler mb-3 mb-md-4 col-12"><hr className="my-0"></hr></div>
					{
					legalMenu.nodes.length ? (
						<BaseMenu wpMenu={ legalMenu } id="menu-legal" className="base-menu col-12 col-md-auto mb-5 mb-md-0" buttonClass="btn btn-sm btn-link text-light py-0"></BaseMenu>
					) : null
					}

					{
					footerOptions.footerCopy ?
						<span className="col-12 col-md-auto mb-0 ms-auto" dangerouslySetInnerHTML={ { __html: sanitize(footerOptions.footerCopy) } }></span>
					: null
					}
				</div>
			</div>

		</footer>
	);
};


export {
	Footer
};
